import axios from 'axios';

export enum ETypZadosti {
    PRID = 'PRID',
    ZRUS = 'ZRUS',
    ZMEN = 'ZMEN',
    REGI = 'REGI'
}

export const zruseniZadosti = (idzadosti: number, typzadosti: ETypZadosti) => {
    return axios({
        method: 'POST',
        url: `/Zadosto${
            typzadosti === ETypZadosti.PRID || typzadosti === ETypZadosti.REGI
                ? ''
                : typzadosti === ETypZadosti.ZRUS
                  ? 'Zruseni'
                  : 'Zmena'
        }ISIN/${idzadosti}/Cancel`
    });
};
